// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__3Ad4M","title":"FrontImage_title__1tXzB"};